import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import { Apis, mockStats } from './constants/api.js'
import { delay, delayTimes } from './constants/common.js'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api'

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000
})

// Interceptor para adicionar token de autenticação
apiClient.interceptors.request.use((config) => {
  const authStore = useAuthStore()
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`
  }
  return config
})



export const getApiStats = async () => {
  await delay(delayTimes.medium)
  
  // Calcular estatísticas baseadas nos dados reais
  const allApis = Apis
  const totalApis = allApis.length
  const activeApis = allApis.filter(api => api.status === 'active').length
  const deprecatedApis = allApis.filter(api => api.status === 'deprecated').length
  
  return {
    totalApis,
    activeApis,
    deprecatedApis
  }
}

export const getRecentApis = async () => {
  await delay(delayTimes.fast)
  
  // Criar uma cópia do array para não modificar o original
  const apisCopy = [...Apis]
  
  // Ordenar APIs por updatedAt em ordem decrescente (mais recente primeiro)
  const sortedApis = apisCopy.sort((a, b) => {
    return new Date(b.updatedAt) - new Date(a.updatedAt)
  })
  
  // Retornar as 3 APIs mais recentes
  return sortedApis.slice(0, 3)
}



export const getAllApis = async () => {
  await delay(delayTimes.slow)
  return Apis
}

export const getApiById = async (id) => {
  await delay(delayTimes.medium)
  return Apis.find(api => api.id === id)
}

export const uploadSwaggerFile = async (data) => {
  await delay(delayTimes.upload)
  console.log('Upload simulado:', data)
  return { success: true, id: Date.now().toString() }
}

export const searchApis = async (query) => {
  await delay(600)
  return Apis.filter(api => 
    api.name.toLowerCase().includes(query.toLowerCase()) ||
    api.description.toLowerCase().includes(query.toLowerCase())
  )
}


// Função para obter o link da API pelo ID
export const getLinkByApiId = (apiId) => {
  const api = Apis.find(api => api.id === apiId)
  return api ? api.fileName : null
} 
